import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

function dm_c04() {
    if ($('.c04-swiper').length) {
        $('.c04-swiper').each(function () {
            const $container = $(this);
            const $swiperContainer = $container.closest('.container-fluid');
            const $navContainer = $swiperContainer.find('.c04-nav');
            const $counter = $swiperContainer.find('.swiper-counter');
            const slideCount = $container.find('.swiper-slide').length;
            const initialSlideIndex = Math.min(2, slideCount - 1);

            if (slideCount === 5) {
                const $clonedSlides = $container.find('.swiper-slide').clone()
                    .attr('data-c04-loop-clone', '')
                    .addClass('no-scroll-reveal');

                $clonedSlides.find('.reveal')
                    .removeClass('scroll-reveal-done')
                    .removeAttr('style');

                $container.find('.swiper-wrapper').append($clonedSlides);
            }

            const prevEl = $('<div class="swiper-button-prev"><div class="btn btn-outline btn-icon icon-left swiper-button-prev"></div></div>');
            const nextEl = $('<div class="swiper-button-next"><div class="btn btn-outline btn-icon icon-right swiper-button-next"></div></div>');
            $navContainer.append(prevEl);
            $navContainer.append(nextEl);

            const swiper = new Swiper(this, {
                modules: [Navigation, Autoplay],
                autoHeight: false,
                centeredSlides: true,
                spaceBetween: 0,
                // autoplay: {
                //     delay: 2500,
                //     disableOnInteraction: false,
                // },
                loop: true,
                speed: 800,
                navigation: {
                    nextEl: nextEl[0],
                    prevEl: prevEl[0],
                },
                breakpoints: {
                    1280: {
                        slidesPerView: 4,
                        slidesOffsetBefore: 50,
                        slidesOffsetAfter: 50,
                        spaceBetween: 24,
                    },
                    768: {
                        slidesPerView: 1.5,
                        spaceBetween: 20,
                        // slidesPerView: 1.74,
                    },
                    0: {
                        slidesPerView: 1.3,
                        // slidesPerView: 1.4,
                    },
                },
                on: {
                    init(swiperInstance) {
                        const totalSlides = parseInt($counter.data('total'), 10);
                        $counter.find('span').eq(0).text(initialSlideIndex + 1);
                        $counter.find('span').eq(2).text(totalSlides);
                        swiperInstance.slideToLoop(initialSlideIndex, 0, false);
                        updateActiveSlide(swiperInstance, $container);
                        setTimeout(() => {
                            swiperInstance.update();
                        }, 100);
                    },
                    slideChange(swiperInstance) {
                        const realIndex = swiperInstance.realIndex % slideCount;
                        $counter.find('span').eq(0).text(realIndex + 1);
                        updateActiveSlide(swiperInstance, $container);
                    },
                    resize(swiperInstance) {
                        swiperInstance.update();
                    },
                    afterResize(swiperInstance) {
                        swiperInstance.update();
                    }
                },
            });

            function updateActiveSlide(swiperInstance, $container, forceIndex = null) {
                const $slides = $container.find('.swiper-slide');
                $slides.removeClass('is-active');
                const activeIndex = forceIndex !== null ? forceIndex : swiperInstance.activeIndex;
                const $active = $slides.eq(activeIndex);
                $active.addClass('is-active');
            }
        });

        // $(window).on('resize', function() {
        //     clearTimeout(resizeTimer);
        //     resizeTimer = setTimeout(function() {
        //         initSwiper();
        //     }, 5);
        // });
    }
}

export { dm_c04 };
